export const achievementData = {
    bio : "Achievements for computer science engineering students often encompass maintaining a commendable GPA throughout their program, actively engaging in research projects, and potentially publishing their findings in respected journals or presenting them at conferences. Additionally, securing internships or co-op positions with esteemed tech companies can provide invaluable hands-on experience and foster essential networking connections for future career prospects. Involvement in coding competitions, hackathons, or open-source software development Lastly, graduating with a well-rounded skill set that includes proficiency in programming languages, algorithms, and the latest technologies is a hallmark achievement",
    achievements : [
        {
            id : 1,
            title : 'Java Full Stack',
            details : 'I have completed Java Full Stack Development from top institution',
            date : '2023',
            field : 'Development',
            image : 'https://www.interviewprotips.com/wp-content/uploads/java-for-full-stack-development-rooman.jpeg'
        },
        {
            id : 2,
            title : 'Web Devlopment',
            details : 'I am former web developer with latest framework',
            date : '2022',
            field : 'Frontend developer',
            image : 'https://www.danielhonrade.com/wp-content/uploads/2020/09/Web-development-1.jpg'
        },
        // {
        //     id : 3,
        //     title : 'Professional Data Engineer Certification',
        //     details : 'Professional Data Engineers enable data-driven decision making by collecting, transforming, and publishing data.',
        //     date : 'Aug 20, 2019',
        //     field : 'Automation',
        //     image : 'https://images.unsplash.com/photo-1489389944381-3471b5b30f04?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80'
        // }

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/